import React from 'react';
import Heatmap from '../../../components/charts/Heatmap';
import { schedulerHeatmap } from '../../../mocks/scheduler';

// Weekly density grid (T7.3). Consumes the Heatmap chart primitive only —
// no direct echarts imports in features/ (T5 done_when).
function CalendarHeatmapView() {
  const data = schedulerHeatmap();

  return (
    <section className="heatmap-card">
      <h2>Run density</h2>
      <p>Runs per hour, Mon–Sun × 00–23. Darker cells mean more scheduled activity.</p>
      <Heatmap data={data} height={260} unit="runs" />
    </section>
  );
}

export default CalendarHeatmapView;
